/**
 * DevPage
 * This is DevPage API contract
 *
 * OpenAPI spec version: 1.1.0
 * Contact: apiteam@swagger.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ContactPageList } from '../model/contactPageList';
import { CreateOrUpdateContactPageRequest } from '../model/createOrUpdateContactPageRequest';
import { ErrorResponse } from '../model/errorResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ContactService {

    protected basePath = 'http://localhost:8090';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param countryCode 
     * @param createOrUpdateContactPageRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addOrUpdateContactPage(countryCode: string, createOrUpdateContactPageRequest: CreateOrUpdateContactPageRequest, observe?: 'body', reportProgress?: boolean): Observable<ContactPageList>;
    public addOrUpdateContactPage(countryCode: string, createOrUpdateContactPageRequest: CreateOrUpdateContactPageRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactPageList>>;
    public addOrUpdateContactPage(countryCode: string, createOrUpdateContactPageRequest: CreateOrUpdateContactPageRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactPageList>>;
    public addOrUpdateContactPage(countryCode: string, createOrUpdateContactPageRequest: CreateOrUpdateContactPageRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (countryCode === null || countryCode === undefined) {
            throw new Error('Required parameter countryCode was null or undefined when calling addOrUpdateContactPage.');
        }
        if (createOrUpdateContactPageRequest === null || createOrUpdateContactPageRequest === undefined) {
            throw new Error('Required parameter createOrUpdateContactPageRequest was null or undefined when calling addOrUpdateContactPage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ContactPageList>(`${this.configuration.basePath}/contact-page/${encodeURIComponent(String(countryCode))}`,
            createOrUpdateContactPageRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContactPages(observe?: 'body', reportProgress?: boolean): Observable<ContactPageList>;
    public getContactPages(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactPageList>>;
    public getContactPages(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactPageList>>;
    public getContactPages(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ContactPageList>(`${this.configuration.basePath}/contact-page`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
